module.exports = __webpack_public_path__ + "static/media/kudu1.75c2f269.jpg";